// What's new in Klap, newest first, for the header bell (components/NewsMenu.tsx).
// An item counts as unread until the user opens the bell once with it listed,
// so give each new item a new `id` (never reuse one) and put it at the top.
// `href` is a klap.app page about the feature: the bell opens it in a new tab
// and the experiment counts its visits ($pageview on its path, without the
// query or hash).

export type NewsItem = {
  id: string;
  title: string;
  body: string;
  href: string;
};

export const NEWS_ITEMS: NewsItem[] = [
  {
    id: "mcp-chatgpt-claude",
    title: "Add Klap to ChatGPT and Claude",
    body: "Klap is now an MCP server. Clip, export and schedule your videos from ChatGPT, Claude, Cursor or any AI agent.",
    // Opens /mcp's install card on ChatGPT, whose app is in ChatGPT's app
    // directory; Claude is the tab next to it.
    href: "/mcp?client=chatgpt#install",
  },
  {
    id: "zapier",
    title: "Klap is now on Zapier",
    body: "Send every new video to Klap, then export, caption and post the best clips with thousands of apps, without code.",
    href: "/integrations/zapier",
  },
];
